<div class="my-device-form">
  <div class="manager-account-section">
    <h1 class="form-title form-title__bp_lt-md_hidden">
      {{ 'stepper.manager_account_title' | translate }}
    </h1>

    <h2>
      {{ 'manage-account.change-password.title' | translate }}
    </h2>
    <div class="ind-form-pw-reset">
      <app-change-password-form
        [form]="changePasswordForm"
        [showErrors]="showErrors"
        [errorsList]="errorsList" />
      <app-button
        label="manage-account.change-password.button-label"
        [className]="'ind-btn--primary'"
        class="ind-btn-wrapper-100"
        (click)="onChangePassword()" />
    </div>

    <h2>
      {{ 'manage-account.delete-account.title' | translate }}
    </h2>
    <p>
      {{ 'manager_account.delete-account.txt' | translate }}
    </p>
    <app-button
      label="buttons.labels.delete"
      [className]="'ind-btn--danger'"
      class="ind-btn-wrapper-100"
      (click)="onAskDelete()" />
  </div>
</div>

<app-modal-delete
  [display]="displayModal$"
  (delete)="onDeleteAccount()"
  (cancel)="onCancelDeleteAccount()" />
